import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

export function useJornada() {
  const [jornada, setJornada] = useState(null);
  const [encontros, setEncontros] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetch() {
      const { data: jornadaData } = await supabase
        .from('mentorias')
        .select('*')
        .eq('slug', 'jornada-ao-oceano')
        .single();

      const { data: encontrosData } = await supabase
        .from('mentoria_encontros')
        .select('*')
        .eq('mentoria_slug', 'jornada-ao-oceano')
        .order('ordem', { ascending: true });

      setJornada(jornadaData || null);
      setEncontros(encontrosData || []);
      setLoading(false);
    }
    fetch();
  }, []);

  return { jornada, encontros, loading };
}
